import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { VALIDATE_TOKEN_ACCOUNT } from 'root/src/shared/descriptions/middlewares/middlewareIds';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const initPointsPayoutAdminEndpoint = {
    [pointsEndpointIds.INIT_POINTS_PAYOUT_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                userId: { type: 'string' },
                amount: { type: 'integer', minimum: 1 },
                payoutCurrency: { type: 'string' },
            },
            required: ['userId', 'amount'],
            additionalProperties: false,
        },
        middlewares: [VALIDATE_TOKEN_ACCOUNT],
    },
};
